export const FEATURE_FLAGS = {
  schemaViolationEventsMvp: 'schemaViolationEventsMvp',
  builderServerAdvancedSettings: 'builderServerAdvancedSettings',
  eventDebuggerEcm: 'eventDebuggerEcm',
  configurableConsentMvp: 'configurableConsentMvp',
  ecmConfigurableConsent: 'ecmConfigurableConsent',
  ecmIabTcfConsent: 'ecmIabTcfConsent',
  consentMode: 'consentMode',
  ecmStandAloneSync: 'ecmStandAloneSync',
  // The LaunchDarkly key predates AJS support.
  ecmStandAloneUnminifyFile: 'ecmStandAloneUnminifyFile',
  botDetection: 'botDetection',
  matchIdConsent: 'matchIdConsent',
  bulkStageAndDeployRebuild: 'bulkStageAndDeployRebuild',
  crossDomainDirect: 'crossDomainDirect',
  crossDomainV1: 'ecmAjsCrossDomainIdentitySync',
  analyticsFilesListViewMvp: 'analyticsFilesListViewMvp',
  ecmMobileBlockCloser: 'ecmMobileBlockCloser',
  analyticsBuilderDownloadUpload: 'analyticsBuilderDownloadUpload',
  ajsOptimizeFileBuild: 'ajsOptimizeFileBuild',
  builderServerQueueTasks: 'builderServerQueueTasks',
  analyticsFilesBulkDownloadUploadAlpha: 'analyticsFilesBulkDownloadUploadAlpha',
  pipelinesBulkActionsAlpha: 'pipelinesBulkActionsAlpha',
  sampleEventsAlpha: 'sampleEventsAlpha',
  orgSwitcherInterstitialMvp: 'orgSwitcherInterstitialMvp',
  webhookConfig: 'webhookConfig',
  pipelineTagsMvp: 'pipelineTagsMvp',
  secretStorageDevelopment: 'secretStorageDevelopment',
  syncConfigRefreshMvp: 'syncConfigRefreshMvp',
  metatagger: 'metatagger',
  // LaunchDarkly key metatagger-tjs-upload (the SDK camel-cases it).
  metataggerTjsUpload: 'metataggerTjsUpload',
  // LaunchDarkly key upload-tagging-file-to-cluster.
  uploadTaggingFileToCluster: 'uploadTaggingFileToCluster',
  auditLogModalMvp: 'auditLogModalMvp',
  auditLogSharedRetrievalMvp: 'auditLogSharedRetrievalMvp',
};
